
//import './jquery/jquery.min.js'
import $ from 'jquery'
import inView from 'in-view/dist/in-view.min.js'
//import owlCarousel from 'owl.carousel'
import simpleLightbox from 'simplelightbox'
import Cookies from 'js-cookie'
import * as basicLightbox from 'basiclightbox'
import mobile from 'is-mobile'

import './partials/tabsSwitch'
//import jScrollability from 'jScrollability/jScrollability.js'

/**
 * Lets init Foundation scripts.
 */
$(document).foundation();

/**
* other functions
*/

function createCookie(name,value,days) {
  if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function svg() {
  $('img.svg').each(function() {
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = jQuery(data).find('svg');

          // Add replaced image's ID to the new SVG
          if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Replace image with new SVG
          $img.replaceWith($svg);

      }, 'xml');
  });
}

window.addEventListener( "pageshow", function ( event ) {
  var historyTraversal = event.persisted || 
                         ( typeof window.performance != "undefined" && 
                              window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    // Handle page restore.
    window.location.reload();
  }
});

$(document).ready(function($) {
  var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

  if (iOS) {
    $('body').addClass('iphone');
  }

  var loaded = true

  svg();

  //$('body').animate({opacity: 1},400);

  var siteURL = "http://" + top.location.host.toString();

  
  $('a[href="#"]').click(function(e){
    e.preventDefault()
  })

  $('main > .row').addClass('blur');

  $('.menu-button').click(function(){
    $('.menu, .cover').fadeIn('slow');
    $('.blur').addClass('active')
  })

  $('.close').click(function(){
    $('.menu, .cover').fadeOut('slow');
    $('.blur').removeClass('active')
  })

   $(".cookies-close").click(function () {
    Cookies.set('cookies-accepted', 'yes', { expires: 31 });
    $(".cookies-regulation").animate({bottom:-150},500).fadeOut();
    return false;
  });

  // home 
  
  $('.scroll-to').click(function(){
    $('html, body').stop(false, true).animate({
      scrollTop: $('.' + $(this).data('scroll-to')).offset().top
    }, 1000);
    this.blur();
    return false;
  });

function handleOutboundLinkClicks(event) {
//  ga('send', 'event', {
//    eventCategory: 'Outbound Link',
//    eventAction: 'click',
//    eventLabel: $(event).attr("href")
//  });
  
  gtag('event', 'click', {
  'event_category' : 'Link',
  'event_label' : $(event).attr("href")
});

    console.log("handleOutboundLinkClicks", ["event", 'Outbound Link', $(event).attr("href")]);
}


$("#menu-item-85 a").click(function( ){
    handleOutboundLinkClicks( this ); 
});
$("#menu-item-25 a").click(function( ){
    handleOutboundLinkClicks( this ); 
});
$(".button_cta_1").click(function( ){
    handleOutboundLinkClicks( this ); 
});
$(".button_cta_2").click(function( ){
    handleOutboundLinkClicks( this ); 
});
$(".play-demo").click(function( ){
    handleOutboundLinkClicks( this ); 
});
$(".play-video").click(function( ){
    handleOutboundLinkClicks( this ); 
});


  if ($('.play-video').length > 0) {
      
    $('.play-video').click(function(){
      
      if (!mobile({"tablet":true})) {      
        let embedUrl = $(this).data('embed');
        basicLightbox.create(`
          <a class="close">&times;</a>
          <div class="resp-container"><iframe src="`+ embedUrl +`" class="resp-iframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>` 
        ).show(); 
        
        $('.basicLightbox .close').click(function(){
          $('.basicLightbox').click();
        })

        return false;
      }
      
    });
   
  }
  
  window.hideCloseButton = function () {
      
    $(".close").hide();
  };
  window.showCloseButton = function () {
     
    $(".close").show();
  };
  
  window.hidePopupLoadingMask = function (){
      console.log("hidePopupLoadingMask");
//      alert("hidePopupLoadingMask");
    setTimeout(function(){ 
    
        $( "#loader" ).fadeOut( "slow", function() {
            $( ".resp-container-filltmp" ).fadeOut( "slow", function() {

                    });
        });
      }, 500);

  }

  function hideLoader(){
    $("#loaderPubluu").css("border","0px solid red");
      
      var iframe = document.getElementById('frameID'),
    iframeWin = iframe.contentWindow || iframe,
    iframeDoc = iframe.contentDocument || iframeWin.document;
    console.log("iframeDoc", iframeDoc);

    $(".resp-container-filltmp").html();
    $("#loaderPubluu").remove();
    var d = new Date();
    $(".resp-container-filltmp").html("<div id='loader'><img id='loaderPubluu' src='https://publuu.com/wp-content/themes/setupo-new/public/images/loader.svg?"+d.getTime()+"'/></div>");

  }
  
  if ($('.play-demo').length > 0) {
    $('.play-demo').click(function(){
        
      if (!mobile({"tablet":true})) {      
        let embedUrl = $(this).data('embed');
        let bgUrl = $(this).data('bg');
        let bgColor = $(this).data('color');
     
        
        
        let bgStyle ="background:url("+bgUrl+"); background-size: cover;  background-position: center; background-color: "+bgColor+"";

        basicLightbox.create("<a class=\"close\">&times;</a>" +
            "<div class='resp-container-filltmp' style='"+bgStyle+"'></div>"+
            "<div class='resp-container' style='"+ bgStyle +"'>" +
            "<iframe src='"+ embedUrl +"' class='resp-iframe' id='frameID' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"+
                "</div>", {
                
        
            }
        ).show(() => hideLoader()) ;
        
        $('.basicLightbox .close').click(function(){
          $('.basicLightbox').click();
        })
        

        return false;
      }
      
    });
   
  }
  
  
  
  

  //var owl = $('.owl-carousel');
  var margin = 0;
//  owl.owlCarousel({
//      autoWidth: true,
//      loop: true,
//      margin: margin,
//      autoplay: true,
//      slideTransition: 'linear',
//      //autoplayTimeout: 7000,
//      autoplaySpeed: 6000,
//      fluidSpeed: true,
//      //autoplayHoverPause: true,
//      responsive:{
//        0:{
//            items:1
//        },
//        600:{
//            items:3
//        },
//        1000:{
//            items:5
//        }
//      }
//  });

  if ($('.with_animations').length > 0) {
    $('.with_animations').each(function(){
      let i = 0;
      $('.animate', this).each(function(){
          $(this).css('animation-delay',i+'s');
          i = i + 0.16;
      });
    });
  }

  inView('.with_animations').on('enter', el => {
    if (loaded === true) {
      [].map.call(el.querySelectorAll('.animate'), function(element) {
        element.classList.add('animate_start')
      });
    }
  });

  inView('.step .large-3').on('enter', el => {
    if (loaded === true) {
      [].map.call(el.querySelectorAll('.step-svg'), function(element) {
        element.classList.add('animate')
      });
    }
  }).on('exit', el => {
    if (loaded === true) {
      [].map.call(el.querySelectorAll('.step-svg.animate'), function(element) {
        element.classList.remove('animate')
      });
    }
  });
  
  // $('.circles_bg .fast').jScrollability('self','parent',function($el,pcnt) {
  //   $el.css({
  //     'left': ((1 - pcnt) * 100) + '%'
  //   });
  // });

  // $('.circles_bg .slow').jScrollability('self','parent',function($el,pcnt) {
  //   $el.css({
  //     //'margin-left': '-' + (20 + ((1 - pcnt) * 60)) + '%'
  //     'margin-left': '-' + ((1 - pcnt) * 100) + '%'
  //   });
  // });
  
  $('.tabs-title').click(function() {
    $('.tabs-title').animate({opacity: 1}, 1, function() {
      Foundation.reInit('equalizer');
    });
  });

  // $('#deeplinked-tabs a').click(function(){
  //   if($(this).parent().hasClass('is-active')) {
  //     //$('#element').foundation('_openTab', $target);
  //     $(this).parent().removeClass('is-active');
  //     $('#deeplinked-tabs a').not($(this)).parent().addClass('is-active');
  //     $('.tabs-panel')
  //   }
  // });

  // faq

  $('.faq-title').click(function () {
    //if (!$(this).parent().hasClass('.active')) {
      $('.faq-posts .active').not($(this).parent()).removeClass('active').find('.faq-content').slideToggle(250);
    //}
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle(250)
  });

  $('.close-faq').click(function () {
    $(this).parent().parent().toggleClass('active');
    $(this).parent().slideToggle(250)
  });

  $('.faq-content').each(function(){
    if($('.text img', this).length > 0) {
      if ($('.text .gallery', this).length > 0) {
        $('.text .gallery a', this).addClass('img').simpleLightbox({
          'disableScroll' : false
        });
      } 
      $('.text a img', this).parent().not('.img').addClass('img').simpleLightbox({
       'disableScroll' : false,
        'nav' : false,
        'showCounter' : false
      });
    }
  });

  $('.footer-menu a').click(function(){
    let hash = $(this).prop("hash");
    if(typeof hash !== 'undefined' && $(hash).length == 1) {
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800);
    }
  })

  $( document ).on( 'nfFormReady', function() {
    $('#nf-field-25').html($('.replace').html());
    $('nf-field:lt(2)').addClass('small-12 medium-6').wrapAll('<div class="row"/>');
    $('nf-field').slice(3,5).addClass('small-12 medium-6').wrapAll('<div class="row"/>');
    let clone = $('.checkbox.svg').clone()
    $('input[type="checkbox"]').each(function(){
      $(this).parent().addClass('pretty p-default p-smooth')
      $(this).after('<div class="state"><label></label></div>')
      $('.checkbox.svg').clone().appendTo($(this).next().children())
    });
    $('input[type="radio"]').each(function(){
      $(this).parent().addClass('pretty p-default p-round p-smooth')
      $(this).after('<div class="state"><label></label></div>')
    });
    svg();
  });
  
  
  
  
  $(window).scroll(function() {
     
    var windscroll = $(window).scrollTop();
//     console.log("windscroll", windscroll );
    if (windscroll >= 10) {
        $("html").attr("data-scroll", windscroll);

    } else {
        $("html").attr("data-scroll", "0");
    }

}).scroll();


$.getScript( "https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.5.1/min/dropzone.min.js" )
            .done(function( script, textStatus ) {
                        $.getScript( "https://publuu.com/wp-content/themes/setupo-new/public/js/component.js" )
                            .done(function( script, textStatus ) {
                            })
                            .fail(function( jqxhr, settings, exception ) {
                                console.log( "Triggered ajaxError handler.", exception );
                            });
                    
            })
            .fail(function( jqxhr, settings, exception ) {
                console.log( "Triggered ajaxError handler.", exception );
            });

});//ready



// WEBPACK FOOTER //
// ./resources/assets/js/app.js